/* eslint-disable no-console,no-undef, camelcase */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  getOrientation,
  resetOrientation,
  checkImage,
  fetchApi
} from "../../../utils/methods";
import { imageErrorMessage } from "../../../utils/constants";
import { withTranslation } from "react-i18next";
import {
  QueAndCard,
} from "./style";
import { Main } from "../../AdminTeamCreation/styles";
import HoverButton from "../../common/HoverButton";
import {
  addQueIcon,
  likertScaleIcon,
  mcqIcon,
  opinionScaleIcon,
  reorderIcon,
  shortDescIcon,
  yesnoIcon,
  Arrows,
  LaunchEventIcon,
  NextArrows,
  UploadIcon,
  closeIcon,
} from "../../../utils/icons";
import {
  CreateSurveyLibraryV2,
  GetSurveyCategories,
  GetSurveyQuestionTypes,
} from "../../../redux/constants/apiConstants";
// import DropDown from "../../common/CommonDropDown/DropDown";
import CommonDropdown from "../../common/CommonDropDown/CommonDropdown";
import { Border } from "../../Journeys/styles";
import { ToggleButton } from "../../Recognition/AddCoreValues/styles";
import { withRouter } from "react-router-dom";
import QuestionReorderPopUp from "./QuestionReorderPopUp";
import CommonButton from "../../common/CommonButton/CommonButton";
import {
  ChallengeHeading,
  ButtonContainer,
  Layout,
  Container,
  InputContainer,
  StyledLabel,
  StyledInputV2,
  UploadPhotoContainer,
  RemoveImageV2,
  InputImage,
  EditorContainer,
} from '../../CreateEvent/style';
import Editor from "../../CKEditor";
import StepNames from "../../CreateEvent/stepNames";
import DynamicStyledTextArea from "./DynamicStyledTextArea";

const opinionpoints = [
  { value: 0, text: "0pt" },
  { value: 10, text: "10pts" },
];

const likeartpoints = [
  { value: 1, text: "1pt" },
  { value: 5, text: "5pts" },
];

const likertScaleValues = [
  { answer: "Strongly Agree", points: 5,label: "Strongly Agree" },
  { answer: "Agree", points: 4,label: "Agree" },
  { answer: "Neutral", points: 3,label: "Neutral" },
  { answer: "Disagree", points: 2,label: "Disagree" },
  { answer: "Strongly Disagree", points: 1,label: "Strongly Disagree" },
];

const opinionScaleValues = [
  { answer: "", points: 0 },
  { answer: "", points: 1 },
  { answer: "", points: 2 },
  { answer: "", points: 3 },
  { answer: "", points: 4 },
  { answer: "", points: 5 },
  { answer: "", points: 6 },
  { answer: "", points: 7 },
  { answer: "", points: 8 },
  { answer: "", points: 9 },
  { answer: "", points: 10 },
];

class CreateSurveyLibrary extends Component {
  constructor(props) {
    super(props);
    this.targetDivRef = React.createRef();
    this.state = {
      imgSrc: "",
      title: "",
      description: "",
      imageName: "",
      step: 1,
      buttonClickScrollTop: false,
      imageUpdate: 0,
      surveyCategories: [],
      selectedSurveyCategory: null,
      selectedSurveyValue: null,
      companyId: props.companyInfo["id"],
      createdSurveyDetails: {},
      surveyQuestionTypes: [],
      questionAnswers: [
        {
          questionType: {},
          question: "",
          questionId: "",
          isFollowUp: false,
          followUpQue: "",
          isMcqWeightage: false,
          multipleMcqResponses: false,
          mcqDropDownOptions: [
            { value: 1, text: "1pt" }
          ],
        },
      ],
      mcqpoints: [
        { value: 1, text: "1pt" },
        { value: 2, text: "2pts" },
      ],
      showQueReorderPopUp: false,
      disable: true,
      messageToEmployeeCharacterCount: 0,
      companyInfo:null,
    };
  }

  _isMounted = false;

  componentDidMount() {
    this._isMounted = true;

    this.fetchSurveyCategories();
    this.fetchQuestionTypes();
    this.setState({
      companyId: this.props.companyDetails?.id
    })
  }


  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate() {
    if (this.state.buttonClickScrollTop) {
      window.scrollTo(0, 0);
      window.setTimeout(() => {
        this.setState({ buttonClickScrollTop: false });
      }, 2000);
    }
  }



  fetchSurveyCategories = async () => {
    let apiUrl = GetSurveyCategories;
    try {
      const res = await fetchApi(apiUrl , "GET");
      if (res?.categories) {
        this.setState({surveyCategories: res?.categories})

      } else {
        toast.error(res?.error);
      }
    } catch (error) {
      window.console.error(error);
    }

  }

  fetchQuestionTypes = async () => {
    let apiUrl = GetSurveyQuestionTypes;
    try {
      const res = await fetchApi(apiUrl , "GET");
      if (res?.["question-types"]) {
        let questionTypes = res["question-types"];
        let modifiedQuestionTypes = questionTypes.map((questionType) => {
          let modifiedName = questionType.name.replace(/-/g, " "); // Remove hyphens
          if (modifiedName === "yes no") {
            modifiedName = "yes or no"; // If name is "yes-no", set it to "yes"
          } else if (modifiedName === "short answer") {
            modifiedName = "short description";
          }
          return {
            id: questionType.id,
            text: modifiedName,
            name: questionType.name,
          };
        });

        this.setState({surveyQuestionTypes: modifiedQuestionTypes,  questionAnswers: [{questionType: modifiedQuestionTypes[0],question: "",isFollowUp: false,}]})

      } else {
        toast.error(res?.error);
      }
    } catch (error) {
      window.console.error(error);
    }

  }

  onChange = (e) => {
    let file = e.target.files[0];
    let fileArr = e.target.files;
    if (e.target.files[0]) {
      if (checkImage(fileArr)) {
        if (file?.size / 1000000 <= 1) {
          let reader = new FileReader();
          reader.readAsDataURL(file);
          const array = document
            .getElementById("event-upload-file")
            .value.split("\\");
          reader.onloadend = () => {
            this.setState({
              imgSrc: reader.result,
              imageName: array[array.length - 1],
            });
            getOrientation(file, (or) => {
              resetOrientation([reader.result], or, (baseImage) => {
                this.setState({
                  imgSrc: baseImage,
                  imageUpdate: 1,
                });
              });
            });
          };
        } else {
          toast.error("Please select image file less than 1MB");
          document.getElementById("event-upload-file").value = "";
        }
      } else {
        toast.error(imageErrorMessage);
        document.getElementById("event-upload-file").value = "";
      }
    }
  };

  onChangeInput = (e) => {
    if (e.target.value.charAt(0) !== " ") {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
  };

  removePhoto = () => {
    this.setState({
      imgSrc: "",
      imageName: "",
    });
  };


  onChangeDescription = (evt) => {
    const newContent = evt.getData();
    const trimmedString = newContent.replace(/\s|&nbsp;/g, "");
    trimmedString.length === 0 ||
    trimmedString.length === 7 ||
    trimmedString == "<p></p><p></p>"
      ? this.setState({ description: "" })
      : this.setState({ description: newContent });
  };

  updateStep = (value) => {
    this.setState({ step: value, buttonClickScrollTop: true });
    // let questionArr = [];
    // let answerArr = [];
    // if(value==3){
    //   this.state.questionAnswers.map((data,index)=>{
    //     let obj={};
    //     let ansObj={};
    //     obj.type=data.questionType.id;
    //     obj.weight=index+1;
    //     obj.question=data.question;
    //     if(data.questionType.id==3){
    //       obj.accept_multiple_responses=data.multipleMcqResponses?true:false;
    //     }
    //     if(data.questionType.id!=1){
    //       ansObj.question_type=data.questionType.id;
    //       if(data.questionType.id==3){
    //         ansObj.answer = data.answers.map((answer) => ({ value: answer.label, points: answer.points }))}
    //       else if(data.questionType.id==5){
    //         if(data.answers[0].points === 1){
    //           ansObj.answer=likertScaleValues
    //         }else{
    //           ansObj.answer=likertScaleValues.slice().sort((a, b) => b.points - a.points)
    //         }
    //       }
    //       else if(data.questionType.id==2){
    //         if(data.answers[0].points === 1){
    //           ansObj.answer=opinionScaleValues
    //         }else{
    //           ansObj.answer=opinionScaleValues.slice().sort((a, b) => b.points - a.points)
    //         }
    //       }
    //       else{
    //         ansObj.answer=data.answers;
    //       }
    //       answerArr.push(ansObj)
    //     }
    //     questionArr.push(obj);
    //   })
    //   this.setState({questionArray: questionArr, answerArray:answerArr})
    // }
  };


  close = () => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_14978_75731"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={24}
        height={24}
      >
        <rect width={24} height={24} fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_14978_75731)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.3605 0.678084C22.6358 -0.0466026 21.4608 -0.0466023 20.7361 0.678084L11.9067 9.50756L3.07795 0.678849C2.4145 0.0154025 1.33884 0.0154032 0.675399 0.678849C0.0119522 1.3423 0.0119521 2.41796 0.675399 3.0814L9.50411 11.9101L0.675642 20.7386C-0.0490441 21.4633 -0.0490441 22.6382 0.675643 23.3629C1.40033 24.0876 2.57528 24.0876 3.29996 23.3629L12.1284 14.5344L20.9577 23.3637C21.6211 24.0271 22.6968 24.0271 23.3602 23.3637C24.0237 22.7002 24.0237 21.6246 23.3602 20.9611L14.531 12.1319L23.3605 3.30241C24.0851 2.57772 24.0851 1.40277 23.3605 0.678084Z"
          fill="#9C9C9C"
        />
      </g>
    </svg>
  );

  renderHeading = () => (
    <ChallengeHeading color={"#005c87"}>
      <div style={{marginRight:"12px"}}>
        <HoverButton
          title={this.props.t("Close")}
          width="24px"
          height="24px"
          svgPath={this.close()}
          onClick={() => this.props.history.goBack()}
          activeColor={"#007AB1"}
          fillOpacity={1}
        />
      </div>
      {this.props.t("Create survey library")}
    </ChallengeHeading>
  );

  stepOneFormData = () => {
    
    const {
      title,
      description,
      step,
    } = this.state;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container color="#005C87">
            <div className="stepsNameHighlight">
              <StepNames stepCount={step} type="survey-library" />
            </div>
            <div className="form">
              <div className="heading">
                <div className="step" >{step}</div>
                <div className="headingName" style={{color:"#005c87"}}>{this.props.t("Survey Introduction")}</div>
              </div>
              <div className="formBody">
                <InputContainer>
                  <StyledLabel color={"#005c87"}>{this.props.t("Title of the survey")}{<span>*</span>}</StyledLabel>
                  <StyledInputV2
                    placeholder={"Write title here..."}
                    name="title"
                    onChange={this.onChangeInput}
                    value={title}
                    maxLength="100"
                    color="#005c87"
                    border={"1px solid #afcbd3"}
                  />
                </InputContainer>

                <Border style={{background:'rgba(0, 92, 135, 0.10)',margin:'20px 0px'}}/>

                <StyledLabel style={{marginTop:"0px"}} color={"#005c87"}>{this.props.t("Survey image")}{<span>*</span>}</StyledLabel>
                <UploadPhotoContainer>
                  <div className="innerDivImageContainer">
                    {this.state.imgSrc ? (
                      <RemoveImageV2 >
                        <img alt="profilre-img" src={this.state.imgSrc}></img>
                        <div className="main-div" onClick={this.removePhoto}>
                          <div className="icon-div" ><div className="sub-icon-div">{closeIcon("white","8","8")}</div></div>
                        </div>
                      </RemoveImageV2>
                    ) : (
                      <div className="uploadImage">
                        <InputImage
                          className="edit-profile-pic "
                          imageReload={1}
                          style={{background:"none"}}
                        >
                          <div className="middle-section">
                            <div>{UploadIcon()}</div>
                            <div className="title">{this.props.t("Upload File")}</div>
                            <div className="sub-title">({this.props.t(".jpeg, .png")})</div>
                            
                          </div>
                          {/* <i className="addImg">{this.props.t("Upload Image")}</i> */}
                          <input
                            id="event-upload-file"
                            type="file"
                            name="user"
                            accept=".jpeg, .png, .jpg"
                            multiple={false}
                            onChange={(e) => this.onChange(e)}
                            onClick={(e) =>
                              e.target.files[0] && this.onChange(e)
                            }
                          />
                        </InputImage>
                      </div>
                    )}
                  </div>
                </UploadPhotoContainer>
                <Border style={{background:'rgba(0, 92, 135, 0.10)',margin:'20px 0px'}}/>
                <InputContainer>
                  <StyledLabel style={{marginTop:"0px"}} color={"#005c87"}>{this.props.t("About the survey")}{<span>*</span>}</StyledLabel>
                  <EditorContainer>
                    <Editor
                      content={description}
                      onChange={this.onChangeDescription}
                    />
                  </EditorContainer>
                </InputContainer>
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };

  stepTwoForm = () => {
    const {
      step,
      surveyQuestionTypes,
      questionAnswers,
      // mcqpoints,
      isActiveOrUpcoming,
      //   isFollowUp,
      selectedSurveyCategory,
      surveyCategories
    } = this.state;
    return (
      <Layout>
        <div className="main">
          {this.renderHeading()}
          <Container>
            <div className="stepsNameHighlight">
              <StepNames stepCount={step} type="survey-library" />
            </div>
            <div className="form">
              <div
                className="heading"
                style={{ justifyContent: "space-between" }}
              >
                <div style={{ display: "flex" }}>
                  <div className="step" style={{ background: "#005C87" }}>
                    {step}
                  </div>
                  <div
                    className="headingName"
                    style={{
                      color: "#005C87",
                      fontFamily: "Rubik-Medium",
                      fontSize: "16px",
                      fontWeight: 500,
                      lineHeight: "24px",
                    }}
                  >
                    How would you like to customize your survey?
                  </div>
                </div>
                {!isActiveOrUpcoming && (
                  <div style={{ display: "flex", marginRight: "15px" }}>
                    <HoverButton
                      title={"Add Question"}
                      svgPath={addQueIcon()}
                      onClick={this.scrollToDiv}
                    />
                    <HoverButton
                      title={"Reorder Questions"}
                      svgPath={reorderIcon()}
                      onClick={() =>
                        this.setState({ showQueReorderPopUp: true })
                      }
                    />
                  </div>
                )}
              </div>

              <CommonDropdown
                tileContainerStyle={{ width: "100%", padding:"0px 0px 20px 0px", margin: "20px 0 0 0" }}
                dropdownStyle={{ top: "95px" }}
                labelText={"Set survey category"}
                isRequired={true}
                dropdownOpen={this.state.so}
                placeholder={this.props.t("Select survey category")}
                title={
                  selectedSurveyCategory
                }
                id="dropdown-recurring"
                onClick={() => this.setState({ so: !this.state.so })}
                data={surveyCategories}
                active={selectedSurveyCategory?.id}
                onSelectParameter={["selectedSurveyCategory", "name"]}
                valueString={""}
                itemValue={true}
                valueIndex={1}
                labelMargin={"0px"}
                onSelect={this.onSelectCategory}
              />
              <Border style={{background:'rgba(0, 92, 135, 0.10)',margin:'20px 0px', display:"flex"}}/>


              <div
                style={{
                  background: "white",
                  // height: "74px",
                  display: "flex",
                  alignItems: "center",
                  width:"100%",
                  marginBottom:"15px"
                }}
              >
                <span
                  style={{
                    color: "rgba(0, 92, 135, 0.60)",
                    fontSize: "16px",
                    fontWeight: "400",
                    lineHeight: "24px",
                  }}
                >
                  Add atleast 5 question for better data generation. min. 2 questions are required
                </span>
              </div>

              <div className="formBody" style={{ padding: "0px" }}>
                {questionAnswers.length ? questionAnswers.map((item, index) => (
                  <React.Fragment key={index}>
                    {/* <div></div> */}
                    <QueAndCard>
                      <div className="header">
                        <div>
                          <span className="title">Question {index + 1}</span>
                        </div>
                        {!isActiveOrUpcoming && (
                          <div
                            onClick={() => {
                              this.deleteQuestionAns(index);
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <span className="delete-icon">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                              >
                                <path
                                  d="M16.563 2.5h-3.438v-.625C13.125.839 12.285 0 11.25 0h-2.5C7.714 0 6.875.84 6.875 1.875V2.5H3.437c-.862 0-1.562.7-1.562 1.563v1.25c0 .345.28.625.625.625h15c.345 0 .625-.28.625-.625v-1.25c0-.863-.7-1.563-1.563-1.563Zm-8.438-.625c0-.345.28-.625.625-.625h2.5c.345 0 .625.28.625.625V2.5h-3.75v-.625ZM3.06 7.188c-.111 0-.2.093-.195.204l.516 10.822A1.873 1.873 0 0 0 5.254 20h9.491a1.873 1.873 0 0 0 1.873-1.786l.515-10.822a.195.195 0 0 0-.195-.205H3.061ZM12.5 8.75a.625.625 0 1 1 1.25 0v8.125a.625.625 0 1 1-1.25 0V8.75Zm-3.126 0a.625.625 0 1 1 1.25 0v8.125a.625.625 0 1 1-1.25 0V8.75Zm-3.125 0a.625.625 0 1 1 1.25 0v8.125a.625.625 0 1 1-1.25 0V8.75Z"
                                  fill="#005C87"
                                  fillOpacity=".6"
                                />
                              </svg>
                            </span>
                          </div>
                        )}
                      </div>
                      <Border
                        style={{
                          background: "rgba(0, 92, 135, 0.30)",
                          margin: "15px 0px",
                        }}
                      />
                      <CommonDropdown
                        data={surveyQuestionTypes}
                        label={"Your type of question"}
                        placeholder="Select type of question"
                        valueIndex={0}
                        dropdownStyle={{ top: "30px" }}
                        onSelectParameter={["text", "id"]}
                        itemValue={true}
                        activeValue={true}
                        title={item?.questionType?.text}
                        displayValue={true}
                        onClick={() => this.setState({ so: !this.state.so })}
                        valueString={""}
                        tileContainerStyle={{
                          width: "100%",
                          // background: "rgba(247, 245, 235, 0.50)",
                          padding: "0px",
                          // color:"#005C87"
                        }}
                        background={
                          isActiveOrUpcoming && "rgba(0, 92, 135, 0.05)"
                        }
                        active={item?.questionType?.id}
                        onSelect={(value) => {
                          this.onQueTypeSelect(index, value, item);
                        }}
                        disabled={isActiveOrUpcoming}
                        height={"60px"}
                        icon={
                          item?.questionType?.name == "short-answer" ? (
                            shortDescIcon()
                          ) :  item?.questionType?.name == "opinion-scale" ? (
                            opinionScaleIcon()
                          ) :  item?.questionType?.name == "multiple-choice" ? (
                            mcqIcon()
                          ) :  item?.questionType?.name == "yes-no" ? (
                            yesnoIcon()
                          ) :  item?.questionType?.name == "likert-scale" ? (
                            likertScaleIcon()
                          ) : (
                            <div
                              style={{
                                background: "white",
                                width: "40px",
                                height: "40px",
                                borderRadius: "3px",
                              }}
                            ></div>
                          )
                        }
                      />
                      <InputContainer>
                        <StyledLabel
                          style={{
                            color: "#005C87",
                            fontFamily: "Rubik-Regular",
                            fontSize: "16px",
                            fontWeight: 400,
                            lineHeight: "20px",
                          }}
                        >
                          What would you like to ask?{<span>*</span>}
                        </StyledLabel>
                        {/* <StyledInputV2
                          placeholder={"Enter the question you want ask"}
                          name="title"
                          onChange={(e) => this.onQueChange(index, e)}
                          value={item.question}
                          // maxLength="50"
                        /> */}
                        <DynamicStyledTextArea
                          key={index}
                          index={index}
                          placeholder={"Enter the question you want to ask"}
                          name={`question-${index}`}
                          onChange={this.onQueChange}
                          value={item.question}
                          maxLength={200}
                        />
                      </InputContainer>

                      { item?.questionType?.name === "opinion-scale" ? (
                        <div className="opinion-scale">
                          <div className="header">
                            <span
                              className="title"
                              style={{ marginTop: "0px" }}
                            >
                              10 Point Scale
                            </span>
                          </div>
                          <div className="point-scale">
                            <div className="point-label">
                              {/* <div>{`"${item &&  item.opinionScale  && item.opinionScale[0].points}" label`}</div> */}
                              <div
                                style={{
                                  color: "rgba(0, 92, 135, 0.60)",
                                  fontFamily: "Rubik-Regular",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  lineHeight: "20px",
                                }}
                              >{`"0" label`}</div>
                              <div className="input-label">
                                <InputContainer>
                                  <StyledInputV2
                                    placeholder={"eg. it was bad"}
                                    name="title"
                                    onChange={(e) =>
                                      this.onOpinionLabelChange(index, e, 0)
                                    }
                                    value={
                                      item?.answers?.[0]?.label
                                    }
                                    maxLength="50"
                                    style={{
                                      // background: "rgba(247, 245, 235, 0.50)",
                                      border:
                                        "1px solid rgba(0, 92, 135, 0.30)",
                                      color: isActiveOrUpcoming
                                        ? "rgba(0, 92, 135,0.6)"
                                        : "rgba(0, 92, 135)",
                                      fontFamily: "Rubik-Medium",
                                      fontSize: "16px",
                                      fontWeight: 500,
                                      lineHeight: "20px",
                                    }}
                                    background={
                                      isActiveOrUpcoming &&
                                      "rgba(0, 92, 135, 0.05)"
                                    }
                                    disabled={isActiveOrUpcoming}
                                  />
                                </InputContainer>
                              </div>
                            </div>
                            <div className="point-dropdown">
                              <CommonDropdown
                                data={opinionpoints}
                                // label={"Your type of question"}
                                placeholder="Select points"
                                valueIndex={0}
                                dropdownStyle={{ top: "30px" }}
                                onSelectParameter={["text", "id"]}
                                itemValue={true}
                                activeValue={true}
                                title={
                                  item?.answers?.[0]?.text
                                }
                                displayValue={true}
                                valueString={""}
                                tileContainerStyle={{
                                  width: "110px",
                                  // background: "#F7F5EB",
                                  padding: "0px",
                                  marginRight: "25px",
                                }}
                                background={
                                  isActiveOrUpcoming && "rgba(0, 92, 135, 0.05)"
                                }
                                disabled={isActiveOrUpcoming}
                                active={
                                  item?.answers?.[0]?.points
                                }
                                onSelect={(value) => {
                                  this.onOpinionPointChange(index, value, 0);
                                }}
                                onClick={() => this.setState({ so: !this.state.so })}
                                height={"60px"}
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                margin: "20px 25px 0px 25px",
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="44"
                                height="18"
                                viewBox="0 0 44 18"
                                fill="none"
                              >
                                <rect
                                  y="6"
                                  width="44"
                                  height="6"
                                  rx="3"
                                  fill="#005C87"
                                />
                                <circle
                                  cx="22"
                                  cy="9"
                                  r="8.5"
                                  fill="#F4AAA9"
                                  stroke="#fff"
                                />
                                <path
                                  d="M20 7h4m-6 2h8m-6 2h4"
                                  stroke="#fff"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </div>

                            <div className="point-label">
                              {/* <div>{`"${item &&  item.answers && item.answers[1].points}" label`}</div> */}
                              <div
                                style={{
                                  color: "rgba(0, 92, 135)",
                                  fontFamily: "Rubik-Regular",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  lineHeight: "20px",
                                }}
                              >{`"10" label`}</div>
                              <div className="input-label">
                                <InputContainer>
                                  <StyledInputV2
                                    placeholder={"eg. it was Perfect"}
                                    name="title"
                                    onChange={(e) =>
                                      this.onOpinionLabelChange(index, e, 1)
                                    }
                                    value={
                                      item?.answers?.[1]?.label
                                    }
                                    maxLength="50"
                                    style={{
                                      // background: "rgba(247, 245, 235, 0.50)",
                                      border:
                                        "1px solid rgba(0, 92, 135, 0.30)",
                                      color: isActiveOrUpcoming
                                        ? "rgba(0, 92, 135,0.6)"
                                        : "rgba(0, 92, 135)",
                                      fontFamily: "Rubik-Medium",
                                      fontSize: "16px",
                                      fontWeight: 500,
                                      lineHeight: "20px",
                                    }}
                                    background={
                                      isActiveOrUpcoming &&
                                      "rgba(0, 92, 135, 0.05)"
                                    }
                                    disabled={isActiveOrUpcoming}
                                  />
                                </InputContainer>
                              </div>
                            </div>

                            <div className="point-dropdown">
                              <CommonDropdown
                                data={opinionpoints}
                                // label={"Your type of question"}
                                placeholder="Select points"
                                valueIndex={0}
                                dropdownStyle={{ top: "30px" }}
                                onSelectParameter={["text", "value"]}
                                itemValue={true}
                                activeValue={true}
                                title={
                                  item?.answers?.[1]?.text
                                }
                                displayValue={true}
                                valueString={""}
                                tileContainerStyle={{
                                  width: "110px",
                                  // background: "#F7F5EB",
                                  padding: "0px",
                                  marginRight: "25px",
                                }}
                                background={
                                  isActiveOrUpcoming && "rgba(0, 92, 135, 0.05)"
                                }
                                disabled={isActiveOrUpcoming}
                                active={
                                  item &&
                                  item.answers &&
                                  item.answers.length &&
                                  item.answers[1] &&
                                  item.answers[1].points
                                }
                                onSelect={(value) => {
                                  this.onOpinionPointChange(index, value, 1);
                                }}
                                onClick={() => this.setState({ so: !this.state.so })}
                                height={"60px"}
                              />
                            </div>
                          </div>
                        </div>
                      ) :  item?.questionType?.name === "likert-scale" ? (
                        <div className="opinion-scale">
                          <div className="header">
                            <span className="title">5 Point Scale</span>
                          </div>
                          {
                            item?.answers.map((ans, ind) => (
                              <div className="point-scale" key={ind}>
                                <div
                                  className="point-label"
                                  style={{ width: "auto" }}
                                  
                                >
                                  {/* <div>{`"${item.opinionScale[0].points}" label`}</div> */}
                                  <div
                                    className="input-label"
                                    style={{ width: "200px" }}
                                  >
                                    <InputContainer>
                                      <StyledInputV2
                                        placeholder={""}
                                        name="title"
                                        // readOnly
                                        onChange={(e) =>
                                          this.onLabelChange(index, e, ind, "answers")
                                        }
                                        value={
                                          ans?.label
                                        }
                                        maxLength="50"
                                      />
                                    </InputContainer>
                                  </div>
                                </div>
                                <div
                                  className="point-dropdown"
                                  style={{ marginTop: "0px" }}
                                >
                                  <CommonDropdown
                                    data={likeartpoints}
                                    placeholder="Select points"
                                    valueIndex={0}
                                    dropdownStyle={{ top: "30px" }}
                                    onSelectParameter={["text", "value"]}
                                    itemValue={true}
                                    activeValue={true}
                                    title={
                                      ans?.points > 1 ? ans?.points + " Pts" : ans?.points + " Pt"
                                    }
                                    displayValue={true}
                                    // valueString={"Points"}
                                    tileContainerStyle={{
                                      width: "110px",
                                      padding: "0px",
                                      marginLeft: "25px",
                                    }}
                                    active={
                                      item?.answers?.[0]?.points
                                    }
                                    onSelect={(value) => {
                                      this.onLikeartPointChange(
                                        index,
                                        value,
                                        0,
                                        "answers"
                                      );
                                    }}
                                    onClick={() => this.setState({ so: !this.state.so })}
                                    height={"48px"}
                                    background={
                                      isActiveOrUpcoming && "rgba(0, 92, 135, 0.05)"
                                    }
                                    disabled={isActiveOrUpcoming || ind > 0}
                                  />
                                </div>
                              </div>))}
                        </div>
                      ) :  item?.questionType?.name === "multiple-choice" ? (
                        <div className="opinion-scale">
                          <div className="header" style={{ marginTop: "15px" }}>
                            <span
                              className="title"
                              style={{ marginTop: "0px" }}
                            >
                              Options
                            </span>
                          </div>
                          {
                            item?.answers.map((ans, ind) => (
                              <div key={ind} className="point-scale">
                                <div className="options">
                                  {String.fromCharCode(ind + 97)}
                                </div>
                                <div
                                  className="point-label"
                                  style={{ width: "300px" }}
                                >
                                  {/* <div>{`"${item.opinionScale[1].points}" label`}</div> */}
                                  <div className="input-label">
                                    <InputContainer>
                                      <StyledInputV2
                                        placeholder={"Add option"}
                                        name="title"
                                        onChange={(e) =>
                                          this.onLabelChange(
                                            index,
                                            e,
                                            ind,
                                            "answers"
                                          )
                                        }
                                        value={ans.label}
                                        maxLength="300"
                                        background={
                                          isActiveOrUpcoming &&
                                          "rgba(0, 92, 135, 0.05)"
                                        }
                                        disabled={isActiveOrUpcoming}
                                      />
                                    </InputContainer>
                                  </div>
                                </div>

                                {!item.multipleMcqResponses && (
                                  <div
                                    className="point-dropdown"
                                    style={{ marginTop: "0px" }}
                                  >
                                    <CommonDropdown
                                      data={item.mcqDropDownOptions}
                                      // label={"Your type of question"}
                                      placeholder="Select points"
                                      valueIndex={0}
                                      dropdownStyle={{ top: "30px" }}
                                      onSelectParameter={["text", "value"]}
                                      itemValue={true}
                                      activeValue={true}
                                      title={ans.text}
                                      displayValue={true}
                                      valueString={""}
                                      tileContainerStyle={{
                                        width: "110px",
                                        // background: "#F7F5EB",
                                        padding: "0px",
                                        marginRight: "25px",
                                      }}
                                      background={
                                        isActiveOrUpcoming &&
                                        "rgba(0, 92, 135, 0.05)"
                                      }
                                      disabled={isActiveOrUpcoming}
                                      active={ans.points}
                                      onSelect={(value) => {
                                        this.onMcqPointChange(
                                          index,
                                          value,
                                          ind,
                                          "answers"
                                        );
                                      }}
                                      height={"60px"}
                                      onClick={() => this.setState({ so: !this.state.so })}
                                    />
                                  </div>
                                )}

                                {item.answers.length > 2 &&
                                  !isActiveOrUpcoming && (
                                  <div
                                    onClick={() => {
                                      this.deleteMcqOption(item, index, ind);
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      marginLeft: "20px",
                                    }}
                                  >
                                    <span className="delete-icon">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="20"
                                        viewBox="0 0 20 20"
                                        fill="none"
                                      >
                                        <path
                                          d="M16.563 2.5h-3.438v-.625C13.125.839 12.285 0 11.25 0h-2.5C7.714 0 6.875.84 6.875 1.875V2.5H3.437c-.862 0-1.562.7-1.562 1.563v1.25c0 .345.28.625.625.625h15c.345 0 .625-.28.625-.625v-1.25c0-.863-.7-1.563-1.563-1.563Zm-8.438-.625c0-.345.28-.625.625-.625h2.5c.345 0 .625.28.625.625V2.5h-3.75v-.625ZM3.06 7.188c-.111 0-.2.093-.195.204l.516 10.822A1.873 1.873 0 0 0 5.254 20h9.491a1.873 1.873 0 0 0 1.873-1.786l.515-10.822a.195.195 0 0 0-.195-.205H3.061ZM12.5 8.75a.625.625 0 1 1 1.25 0v8.125a.625.625 0 1 1-1.25 0V8.75Zm-3.126 0a.625.625 0 1 1 1.25 0v8.125a.625.625 0 1 1-1.25 0V8.75Zm-3.125 0a.625.625 0 1 1 1.25 0v8.125a.625.625 0 1 1-1.25 0V8.75Z"
                                          fill="#005C87"
                                          fillOpacity=".6"
                                        />
                                      </svg>
                                    </span>
                                  </div>
                                )}
                              </div>
                            ))}

                          <div className="more-option">
                            <span
                              onClick={() =>
                                !isActiveOrUpcoming && this.addOptions(index)
                              }
                              style={{
                                color:
                                  isActiveOrUpcoming &&
                                  "rgba(0, 92, 135, 0.60)",
                                cursor: isActiveOrUpcoming && "default",
                              }}
                            >
                              Add More Option (Max 10)
                            </span>
                          </div>

                          {/* <div className="toggle-btn">
                            <ToggleButton style={{ position: "unset" }} disabled={isActiveOrUpcoming}>
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={item.isMcqWeightage}
                                  onChange={() => {
                                    !isActiveOrUpcoming && this.onFollowUpToggle(index,"isMcqWeightage",item);
                                  }}
                                  disabled={isActiveOrUpcoming}
                                />
                                <span className="slider round"></span>
                              </label>
                            </ToggleButton>
                            <div className="toggle-label">
                            Do you want to set weightage for Options
                            </div>
                          </div> */}

                          <div className="toggle-btn">
                            <ToggleButton
                              style={{ position: "unset" }}
                              disabled={isActiveOrUpcoming}
                            >
                              <label className="switch">
                                <input
                                  type="checkbox"
                                  checked={item.multipleMcqResponses}
                                  onChange={() => {
                                    !isActiveOrUpcoming &&
                                      this.onFollowUpToggle(
                                        index,
                                        "multipleMcqResponses",
                                        item
                                      );
                                    // this.createSurveyQues(item, index);
                                  }}
                                  disabled={isActiveOrUpcoming}
                                />
                                <span className="slider round"></span>
                              </label>
                            </ToggleButton>
                            <div className="toggle-label">
                              Allow respondents to select multiple answers
                            </div>
                          </div>
                        </div>
                      ) :  item?.questionType?.name === "yes-no" ? (
                        <div
                          className="opinion-scale"
                          style={{ marginTop: "15px" }}
                        >
                          <div className="header" style={{ marginTop: "0px" }}>
                            <span
                              className="title"
                              style={{ marginTop: "0px" }}
                            >
                              Options
                            </span>
                          </div>

                          {item &&
                            item.answers &&
                            item.answers.map((ans, ind) => (
                              <div key={ind} className="point-scale">
                                <div className="options">
                                  {String.fromCharCode(ind + 97)}
                                </div>
                                <div
                                  className="point-label"
                                  style={{ width: "300px" }}
                                >
                                  {/* <div>{`"${item.opinionScale[1].points}" label`}</div> */}
                                  <div className="input-label">
                                    <InputContainer>
                                      <StyledInputV2
                                        placeholder={""}
                                        readOnly
                                        name="title"
                                        onChange={(e) =>
                                          this.onLabelChange(
                                            index,
                                            e,
                                            ind,
                                            "answers"
                                          )
                                        }
                                        value={ans.label}
                                        // maxLength="50"
                                        style={{
                                          background: "rgba(0, 92, 135, 0.05)",
                                          border:
                                            "1px solid rgba(0, 92, 135, 0.30)",
                                          color: "rgba(0, 92, 135, 0.60)",
                                          fontFamily: "Rubik-Medium",
                                          fontSize: "16px",
                                          fontWeight: 400,
                                          lineHeight: "20px",
                                        }}
                                      />
                                    </InputContainer>
                                  </div>
                                </div>

                                <div
                                  className="point-dropdown"
                                  style={{ marginTop: "0px" }}
                                >
                                  <CommonDropdown
                                    data={likeartpoints}
                                    // label={"Your type of question"}
                                    placeholder="Select points"
                                    valueIndex={0}
                                    dropdownStyle={{ top: "30px" }}
                                    onSelectParameter={["text", "value"]}
                                    itemValue={true}
                                    activeValue={true}
                                    title={ans.text}
                                    displayValue={true}
                                    valueString={""}
                                    tileContainerStyle={{
                                      width: "110px",
                                      // background: "rgba(247, 245, 235, 0.50)",
                                      padding: "0px",
                                      marginRight: "25px",
                                    }}
                                    active={ans.points}
                                    onSelect={(value) => {
                                      this.onYesNoPointChange(
                                        index,
                                        value,
                                        ind,
                                        "answers"
                                      );
                                    }}
                                    background={
                                      isActiveOrUpcoming &&
                                      "rgba(0, 92, 135, 0.05)"
                                    }
                                    disabled={isActiveOrUpcoming}
                                    height={"60px"}
                                    onClick={() => this.setState({ so: !this.state.so })}
                                  />
                                </div>
                              </div>
                            ))}
                        </div>
                      ) : null}

                      {/* {item.questionType.name != "short-answer" && <div className="follow-up">
                        <div className="title">
                          <span>Would you like more detail?</span>
                        </div>
                        <div className="toggle-btn">
                          <ToggleButton style={{ position: "unset" }} disabled={isActiveOrUpcoming}>
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={item.isFollowUp}
                                onChange={() => {
                                  this.onFollowUpToggle(index, "isFollowUp", item);
                                }}
                                disabled={isActiveOrUpcoming}
                              />
                              <span className="slider round"></span>
                            </label>
                          </ToggleButton>
                          <div className="toggle-label">
                            Ask follow-up question
                          </div>
                        </div>
                      </div>}

                      {(item.isFollowUp && item.questionType.name != "short-answer") && (
                        <div style={{ marginTop: "15px" }}>
                          <StyledInputV2
                            placeholder={"eg. What would you suggest?"}
                            name="title"
                            onChange={(e)=>{this.onFollowUpQueChange(index, e); }}
                            value={item.followUpQue}
                            // maxLength="50"
                            style={{
                              background: "rgba(247, 245, 235, 0.50)",
                              border: "1px solid rgba(0, 92, 135, 0.30)",
                              color: "#005C87",fontFamily: "Rubik-Medium",fontSize: "16px",fontWeight: 400,lineHeight: "24px"
                            }}
                          />
                        </div>
                      )} */}
                    </QueAndCard>

                    <div
                      style={{ height: "25px", background: "white" }}
                    ></div>
                  </React.Fragment>
                )):null}

                {!isActiveOrUpcoming && (
                  <div className="addex" ref={this.targetDivRef}>
                    <button onClick={this.addNewQue}>+ Add New Question</button>
                  </div>
                )}
              </div>
            </div>
          </Container>
        </div>
      </Layout>
    );
  };


  onQueTypeSelect = (index, value, item) => {
    const questionAnswers = [...this.state.questionAnswers];
    questionAnswers[index].questionType = value;
    if (value.name === "opinion-scale") {
      questionAnswers[index].answers = [
        { label: "", points: 0, text: "0pts" },
        { label: "", points: 10, text: "10pts" },
      ];
    } else if (value.name === "multiple-choice") {
      questionAnswers[index].answers = [
        { label: "", points: 1, text: "1pt" },
        { label: "", points: 1, text: "1pt" },
      ];
      questionAnswers[index].mcqDropDownOptions = [
        { value: 1, text: "1pt" }
      ];
      questionAnswers[index].isMcqWeightage = true;
      questionAnswers[index].multipleMcqResponses = false;
    } else if (value.name === "yes-no") {
      questionAnswers[index].answers = [
        { label: "Yes", points: 5, text: "5pts" },
        { label: "No", points: 1, text: "1pt" },
      ];
    } else if (value.name === "likert-scale") {
      questionAnswers[index].answers = JSON.parse(JSON.stringify(likertScaleValues));
    }
    this.setState({ questionAnswers: questionAnswers });

    if (item.questionId) {
    //   this.createSurveyQues(item, index, item.isFollowUp);
    }
  };

  onQueChange = (index, event) => {
    const { questionAnswers } = this.state;
    questionAnswers[index].question = event.target.value;
    this.setState({ questionAnswers: questionAnswers });
    this.areAllValuesNotEmpty(questionAnswers);
  };

  onFollowUpToggle = (index, name, /*item*/) => {
    const { questionAnswers } = this.state;
    questionAnswers[index][name] = !questionAnswers[index][name];
    this.setState({ questionAnswers: questionAnswers }, () => {
      if (name == "multipleMcqResponses") {
        // this.createSurveyQues(item, index);

        if (questionAnswers[index]["multipleMcqResponses"]) {
          questionAnswers[index]["isMcqWeightage"] = false;
        } else {
          questionAnswers[index]["isMcqWeightage"] = true;

          // for (let i = 0; i < questionAnswers[index]["answers"].length; i++) {
          //   (questionAnswers[index]["answers"][i].text =
          //     i + 1 > 1 ? i + 1 + "pts" : i + 1 + "pt"), (questionAnswers[index]["answers"][i].points = i + 1);
          // }
          // {text:j + 1 > 1? (j + 1) + "pts": (j + 1) + "pt", value:j + 1}
          // this.setState({ questionAnswers: questionAnswers },()=>{this.onOpinionLabelBlur(index, "answers")});
        }
        this.setState({ questionAnswers: questionAnswers });
      } else if (name == "isMcqWeightage") {
        // this.onOpinionLabelBlur(index, "answers");
      }

      // name == "multipleMcqResponses" && this.createSurveyQues(item, index);name == "isMcqWeightage" && this.onOpinionLabelBlur(index, "answers")
    });
  };

  addNewQue = () => {
    let questionAnswers = [...this.state.questionAnswers];
    let allsurveyQuestionTypes = [...this.state.surveyQuestionTypes];
    let shortDesc = allsurveyQuestionTypes.filter(
      (item) => item.name === "short-answer"
    );
    questionAnswers.push({
      questionType: shortDesc[0],
      question: "",
      isFollowUp: false,
    });
    this.setState({ questionAnswers: questionAnswers }, () =>
      this.areAllValuesNotEmpty(this.state.questionAnswers)
    );
  };


  onFollowUpQueChange = (index, event) => {
    const { questionAnswers } = this.state;
    questionAnswers[index].followUpQue = event.target.value;
    this.setState({ questionAnswers: questionAnswers });
  };


  onOpinionLabelChange = (index, e, labelIndex) => {
    const { questionAnswers } = this.state;
    questionAnswers[index].answers[labelIndex].label = e.target.value;
    this.setState({ questionAnswers: questionAnswers });
  };

  onOpinionLabelBlur = (index, name) => {
    const { questionAnswers } = this.state;
    this.createSurveyAns(
      questionAnswers[index],
      index,
      questionAnswers[index][name]
    );
  };

  onOpinionPointChange = (index, value, labelIndex) => {
    const { questionAnswers } = this.state;
    // questionAnswers[index].opinionScale[labelIndex].value = value.value;
    if (labelIndex === 0 && value.value === 0) {
      questionAnswers[index].answers[labelIndex].text = value.text;
      questionAnswers[index].answers[labelIndex].points = value.value;
      questionAnswers[index].answers[1].text = "10pts";
      questionAnswers[index].answers[1].points = 10;
    } else if (labelIndex === 0 && value.value === 10) {
      questionAnswers[index].answers[labelIndex].text = value.text;
      questionAnswers[index].answers[labelIndex].points = value.value;
      questionAnswers[index].answers[1].text = "0pts";
      questionAnswers[index].answers[1].points = 0;
    }
    if (labelIndex === 1 && value.value === 0) {
      questionAnswers[index].answers[labelIndex].text = value.text;
      questionAnswers[index].answers[labelIndex].points = value.value;
      questionAnswers[index].answers[0].text = "10pts";
      questionAnswers[index].answers[0].points = 10;
    } else if (labelIndex === 1 && value.value === 10) {
      questionAnswers[index].answers[labelIndex].text = value.text;
      questionAnswers[index].answers[labelIndex].points = value.value;
      questionAnswers[index].answers[0].text = "0pts";
      questionAnswers[index].answers[0].points = 0;
    }

    this.setState({ questionAnswers: questionAnswers });
  };

  onLabelChange = (index, e, labelIndex, name) => {
    const { questionAnswers } = this.state;
    questionAnswers[index][name][labelIndex].label = e.target.value;
    this.setState({ questionAnswers: questionAnswers });
  };


  onLikeartPointChange = (index, value, labelIndex, name) => {
    const { questionAnswers } = this.state;
    const maxPoints = 5;
  
    // Loop through all dropdowns
    for (let i = 0; i < maxPoints; i++) {
      const adjustedPoints = value.value === 1 ? i + 1 : maxPoints - i;
  
      questionAnswers[index][name][i].text = `${adjustedPoints}pts`;
      questionAnswers[index][name][i].points = adjustedPoints;
  
      // Enable only the first dropdown, disable the rest
      questionAnswers[index][name][i].disabled = i !== 0;
    }
  
    this.setState({ questionAnswers });
  };

  onYesNoPointChange = (index, value, labelIndex, name) => {
    const { questionAnswers } = this.state;
    questionAnswers[index].isupdated = true;
    const oppositeIndex = labelIndex === 0 ? 1 : 0;
    const oppositePoints = value.value === 1 ? 5 : 1;
  
    questionAnswers[index][name][labelIndex].text = value.text;
    questionAnswers[index][name][labelIndex].points = value.value;
    questionAnswers[index][name][oppositeIndex].text = `${oppositePoints}pts`;
    questionAnswers[index][name][oppositeIndex].points = oppositePoints;
  
    this.setState({ questionAnswers });
  };

  onMcqPointChange = (index, value, labelIndex, name) => {
    const { questionAnswers } = this.state;

    questionAnswers[index][name][labelIndex].text = value.text;
    questionAnswers[index][name][labelIndex].points = value.value;

    this.setState({ questionAnswers: questionAnswers });
  };



  deleteMcqOption = (item, index, ind) => {
    const { questionAnswers } = this.state;

    const modifiedQuestionAnswers=[...questionAnswers];
    modifiedQuestionAnswers[index].answers.splice(ind, 1);

    // let modifiedmcqpoints = [];

    // questionAnswers[index].mcqDropDownOptions = modifiedmcqpoints;

    this.setState(
      { questionAnswers: modifiedQuestionAnswers }
    );
  };

  addOptions = (index) => {
    const { questionAnswers, mcqpoints } = this.state;

    if (questionAnswers[index].answers.length < 10) {
      const newOption = {
        label: "",
        points:  1,
        text:
          1 + "pt",
      };

      questionAnswers[index].answers.push(newOption);

      // Update the state with the new option
      this.setState({ questionAnswers: questionAnswers, mcqpoints: mcqpoints });
    }
  };

  deleteQuestionAns = async (index) => {

    let questions = [...this.state.questionAnswers]
    questions.splice(index, 1);
    this.setState({questionAnswers:questions});

  };

  onSelectPoints = (name, /*value, key*/) => {
    this.setState({
      selectedSurveyPoint: name.value
    });
  };

  onSelectCategory = (name, /*value, key*/) => {
    this.setState({
      selectedSurveyCategory: name.name,
      selectedSurveyValue: name.id
    });
  };




  scrollToDiv = () => {
    if (this.targetDivRef.current) {
      this.targetDivRef.current.scrollIntoView({ behavior: "smooth" });
    }
    this.addNewQue();
  };

  onDragStart = (event, index) => {
    event.dataTransfer.setData("dragIndex", index);
  };

  onDragOver = (event) => {
    event.preventDefault();
  };

  onDrop = (event, dropIndex) => {
    const dragIndex = event.dataTransfer.getData("dragIndex");
    const { questionAnswers } = this.state;
    const items = [...questionAnswers];
    const draggedItem = items[dragIndex];

    // // Remove the item from the original position
    items.splice(dragIndex, 1);

    // // Insert the dragged item at the new position
    items.splice(dropIndex, 0, draggedItem);
    // this.createSurveyQues(questionAnswers[dropIndex], Number(dragIndex));
    // this.createSurveyQues(questionAnswers[dragIndex], Number(dropIndex));

    // questionAnswers = items;

    this.setState({ questionAnswers: items });
  };


  areAllValuesNotEmpty(arr) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].question == "") {
        this.setState({ disable: true });
        // setDisable(true)
      } else {
        // setDisable(false)
        this.setState({ disable: false });
      }
    }
  }

  changeStep = (value) => {
    this.setState({ step: value });
  }

  convertQuestionsAnswers(data) {

    const getLikertOrOpinionScaleAnswers = (item, ans) => {
      if (item.questionType.name === "opinion-scale") {

        const result = ans?.[0]?.points === 0
          ? opinionScaleValues
          : opinionScaleValues.map((item, index) => ({
            answer: opinionScaleValues[opinionScaleValues.length - 1 - index].points,
            points: opinionScaleValues[opinionScaleValues.length - 1 - index].points,
          }));
    
        // Update values and labels
        result.forEach((item, index) => {

          if (index === 0 || index === 10) {
            item.answer = ans[index === 0 ? 0 : 1].answer;
          } else{
            item.answer = index.toString();
          }
        });
        return result;
      }
      return ans; // Return the original answers if not likert-scale or opinion-scale
    };
  
    return {
      questions_answers: data.map((item, index) => {
        const questionType = item.questionType ? item.questionType.id : null;
        const acceptMultipleResponses =
          item.questionType && item.questionType.name === "multiple-choice"
            ? item.multipleMcqResponses
              ? 1
              : 0
            : 0;
  
        let answers = item.answers
          ? item.answers.map((answer) => ({
            answer: answer.label || answer.text,
            points: answer.points,
          }))
          : [];
  
        // Apply the Likert or Opinion Scale values if applicable
        answers = getLikertOrOpinionScaleAnswers(item, answers);
  
        return {
          question: item.question,
          question_type_id: questionType,
          accept_multiple_responses: acceptMultipleResponses,
          question_order: index + 1,
          answers: answers,
        };
      }),
    };
  }

  postSurveyLibrary = async(payload)=>{
    this.setState({disable:true})
    try{
      const res = await fetchApi(CreateSurveyLibraryV2,"POST",payload);
      console.log("res",res)
      if(res.status === "failed"){
        toast.error(res?.data?.message)
      }else if(res.status === "success"){
        toast.success(res.data[0]);
        this.props.history.push({pathname:"/company/surveys/library",state:{type: this.props.role === "ADMIN" ? "wolib" : "organization"}});
        // this.props.history.push("/company/surveys/library")
      }
      this.setState({disable:false});
    }catch (error) {
      window.console.error(error);
      this.setState({disable:false});
    }
  }

  onSubmit = ()=>{

    const{title,description,companyId,questionAnswers,imgSrc,selectedSurveyValue}=this.state;

    let payload = {
      title:title,
      description:description,
      image:imgSrc,
      company_id:this.props.role === "ADMIN" ? null : companyId,
      category_id:selectedSurveyValue,
      questions_answers:this.convertQuestionsAnswers(questionAnswers).questions_answers
    }

    // console.log("payload",payload)

    this.postSurveyLibrary(payload);

  }

  validateQuestionAnswers = () => {

    let finalQuestionAnswers =[...this.state.questionAnswers];
    let isValid = true;
    let errors = [];
  
    finalQuestionAnswers?.forEach((item, index) => {
      const { question, answers,questionType } = item;
  
      // Validate question
      if (!question || question.trim() === "" ||  !questionType.id) {
        isValid = false;
        errors.push(`Question at index ${index} is empty.`);
      }
  
      // Validate answers
      if(question?.questionType?.name != "short-answer"){
        answers?.forEach((answer, ansIndex) => {
          // console.log("answer + index", answer, "index",index);
          const { label, points, /*text*/ } = answer;
    
          if (!label || label.trim() === "") {
            // console.log("if answer + index", answer, "index",index);
            isValid = false;
            errors.push(`Label is empty in answer ${ansIndex + 1} of question ${index + 1}.`);
          }
          if (points.toString().trim() === "") {
            isValid = false;
            errors.push(`Points are empty in answer ${ansIndex + 1} of question ${index + 1}.`);
          }

        });
      }
    });

    // console.log("isValid", isValid);
  
    // return { isValid, errors };
    return isValid;
  };

  render() {
    const {
      step,
      title,
      imgSrc,
      description,
      showQueReorderPopUp,
      questionAnswers,
      disable,
      selectedSurveyCategory
    } = this.state;
    return (
      <React.Fragment>
        {step === 1
          ? this.stepOneFormData()
          : step === 2
            ? this.stepTwoForm() : null
        }
        {step === 1 ? (
          <ButtonContainer isPosition={true}>
            <Main>
              <CommonButton
                btnType={"squareIcon"}
                onClick={() => this.updateStep(2)}
                title={this.props.t("Next")}
                styles={{color:"#007AB1"}}
                disabled={!title ||!imgSrc ||!description}
                nextIcon={NextArrows("white")}
              />
            </Main>
          </ButtonContainer>
        ) : step === 2 && (
          <ButtonContainer isPosition={true}>
            <div className="wrapper">
              <CommonButton
                btnType={"squareIcon"}
                styles={{color:"white",textColor:"#007AB1",border:"#007AB1",width:"200px", marginLeft:"0px",display:"flex",justifyContent:"center",alignItems:"center"}}
                onClick={() => this.updateStep(1)}
                title={this.props.t("Go Back")}
                icon={Arrows()}
              />
              <CommonButton
                btnType={"squareIcon"}
                styles={{color:"#007AB1", marginAuto:'auto'}}
                onClick={() => this.onSubmit()}
                title={this.props.t("Submit")}
                nextIcon={LaunchEventIcon()}
                disabled={disable||!selectedSurveyCategory || !this.validateQuestionAnswers() || questionAnswers.length < 2}
              />
            </div>
          </ButtonContainer>
        )
        }
        {showQueReorderPopUp && (
          <QuestionReorderPopUp
            headerText={"Reorder Questions"}
            showModal={showQueReorderPopUp}
            companyId={this.state.companyId}
            updateStep={this.updateStep}
            onClose={() => {
              this.setState({ showQueReorderPopUp: false });
            }}
            questions={questionAnswers}
            onDragStart={this.onDragStart}
            onDragOver={this.onDragOver}
            onDrop={this.onDrop}
          />
        )}
      </React.Fragment>
    );
  }
}

CreateSurveyLibrary.propTypes = {
  history: PropTypes.object.isRequired,
  role: PropTypes.string.isRequired,
  t: PropTypes.func,
  companyInfo: PropTypes.object.isRequired,
  allowChallengeEventForSpouseDependent: PropTypes.func,
  companyDetails: PropTypes.object,
  fetchCompanyForUser: PropTypes.func
};

const mapStateToProps = (state) => ({
  userCompany: state.profileData.userCompany,
  companyDetails: state.profileData.companyDetails,
});


export default withRouter(connect(mapStateToProps , null)(withTranslation()(CreateSurveyLibrary)));
